export function callMultiple(...callbacks) {
    return (...args) => callbacks.forEach((callback) => {
        callback === null || callback === void 0 ? void 0 : callback(...args);
    });
}
//# sourceMappingURL=callMultiple.js.map